const accessTerm = {
  display: {
    go_to_home: 'Ir para Início',
    password_info: 'Essa senha de acesso tem a duração de um ano a partir da data desta validação.',
    print_access_term: 'Imprimir Termo de Acesso',
    more_info: 'Saiba mais',
    company_name: 'Clicksign Gestão de Documentos S.A.',
    document_access_term: 'Termo de Acesso a Documento Eletrônico',
    validation: 'Validação',
    original_eletronic_info:
      'Este termo contém informações para acesso ao original eletrônico do seguinte documento:',
    how_to_access: 'Como acessar e validar o documento eletrônico',
    instruction:
      'Siga as instruções abaixo para acessar o inteiro teor do documento assinado eletronicamente, bem como para validar os signatários e respectivos pontos de autenticação.',
    how_to_access_document: 'Para acessar o documento através de senha:',
    how_to_access_via_qrcode: 'Para acessar o documento através de QR Code',
    password: 'Senha de acesso',
    qrcode_access: 'QR Code de acesso',
    qrcode_description:
      'Utilize um leitor de QR Code para ser direcionado para a página de validação deste documento na Clicksign.',
    access_validator: 'Acesse: ',
    password_validator: 'Clique no botão “Validar com senha”.',
    type_password: 'Digite a senha ao lado e clique em “Validar”.',
    validator_site: 'https://www.clicksign.com/validador.',
    file_hash: 'Hash do arquivo validado (SHA256): ',
    validate_another_document: 'Validar outro documento',
    print: 'Imprimir',
  },
  generate_password: {
    title: 'Validar documento a partir de Senha',
    subtitle: 'Tenho a senha de acesso ao documento que quero validar na Clicksign.',
    validate: 'Validar',
  },
  result: {
    seeTheDocument: 'Veja o documento.',
    seeDocument: 'Ver documento e validar assinaturas',
    downloadDocument: 'Baixar documento',
  },
};

export default accessTerm;
